import { Redirect } from 'react-router';
import type ObjectivePreviewDto from '../../../../../../types/ObjectivePreviewDto';
import api from '../../../../../api';
import { OBJECTIVE_SINGLE } from '../../../../../routes';
import { withPageData } from '../../../../hoc/withPageData';
import { interpolateUrl } from '../../../../services/Url';

type OuterProps = {
    objectiveId: string;
};

type InnerProps = {
    objective: ObjectivePreviewDto;
};

function ObjectiveSingleById({ objective }: InnerProps) {
    return (
        <Redirect to={interpolateUrl(OBJECTIVE_SINGLE, { objectiveId: objective.id, cycleId: objective.cycleId })} />
    );
}

export default withPageData<InnerProps, OuterProps>({
    resolve: {
        objective: ({ objectiveId }) => api.objectivePreview.getObjective(objectiveId),
    },
})(ObjectiveSingleById);
